@import "../shared.css";

:host {
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	position: relative;
	background-color: rgb(var(--smoothly-input-background));
	color: rgb(var(--smoothly-input-foreground));
	fill: rgb(var(--smoothly-input-foreground));
	stroke: rgb(var(--smoothly-input-foreground));
	padding-left: var(--input-padding-side);
}

:host.open {
	border-radius: var(--smoothly-input-border-radius) var(--smoothly-input-border-radius) 0 0;
}


:host>.select-display {
	box-sizing: border-box;
	display: flex;
	padding: var(--input-value-padding-top) .8rem var(--input-value-padding-bottom) 0;
	overflow: hidden;
	width: 100%;
	white-space: nowrap;
	gap: 1rem;
	text-overflow: ellipsis;
}
:host:not([readonly]):not([disabled])>.select-display {
	cursor: pointer;
}

:host:not(:has([slot=label]))>.select-display,
:host:not([show-label])>.select-display  {
	padding: .6rem .8rem .6rem 0;
	align-items: center;
}

:host>.select-display smoothly-icon {
	color: rgb(var(--smoothly-input-foreground));
	fill: rgb(var(--smoothly-input-foreground));
	stroke: rgb(var(--smoothly-input-foreground));
}

:host>div.icons {
	display: flex;
	flex-direction: row;
	align-items: center;
}

:host:hover>div.icons::slotted(smoothly-icon) {
	filter: opacity(100%);
}

:host>div.icons>smoothly-icon[name=caret-down-outline],
:host>div.icons>smoothly-icon[name=caret-forward-outline] {
	opacity: .7;
	height: 100%;
	padding-inline: var(--input-padding-side);
}
:host:not([readonly]):not([disabled])>div.icons>smoothly-icon[name=caret-down-outline],
:host:not([readonly]):not([disabled])>div.icons>smoothly-icon[name=caret-forward-outline] {
	cursor: pointer;
}

:host[invalid]>div>smoothly-icon.smoothly-invalid {
	display: block;
	padding: 0.5rem;
}

:host>div>smoothly-icon.smoothly-invalid {
	display: none
}


:host.has-value:has([slot=label]:not(:empty))>.select-display,
:host:not(.has-value)[placeholder]>.select-display {
	overflow: hidden;
	width: 100%;
}


:host>.dropdown {
	display: flex;
	flex-direction: column;
	position: absolute;
	top: var(--element-height);
	z-index: 20;
	max-height: var(--menu-height, unset);
	overflow-x: hidden;
	overflow-y: auto;
	background-color: rgb(var(--smoothly-input-background));
	inset-inline: 0;
	border-radius: 0 0 var(--smoothly-input-border-radius) var(--smoothly-input-border-radius);
	border: rgb(var(--smoothly-input-border, var(--smoothly-color-contrast))) solid 1px;
	border-top: rgba(var(--smoothly-input-border, var(--smoothly-color-contrast)), .4) solid 1px;
}
:host:not(.open)>.dropdown {
	border: 0;
}
:host[looks="grid"]>.dropdown,
:host[looks=border]>.dropdown,
:host[looks="transparent"]>.dropdown {
	inset-inline: -1px;
}

:host>.dropdown>.search {
	display: flex;
	position: sticky;
	align-items: center;
	top: 0;
	gap: 1rem;
	padding: .7rem .7rem .7rem .25rem;
	background-color: rgb(var(--smoothly-input-background));
	color: rgb(var(--smoothly-input-foreground, var(--smoothly-color-contrast)));
	fill: rgb(var(--smoothly-input-foreground, var(--smoothly-color-contrast)));
	stroke: rgb(var(--smoothly-input-foreground, var(--smoothly-color-contrast)));
}
:host:not(.has-filter)>.dropdown>.search {
	/* hide search */
	/* search cant be display: none, since it is the focus element */
	height: 0;
	padding: 0;
	overflow: hidden;
	pointer-events: none;
}
:host>.dropdown>.search::before {
	/* search have opacity without showing what is underneath */
	content: "";
	position: absolute;
	inset: 0;
	background-color: rgba(var(--smoothly-primary-tint), 0.5);
	z-index: -1;
}
:host>.dropdown>.search>.search-input {
	width: 100%;
	background-color: transparent;
	border: none;
	outline: none;
}
:host>.dropdown>.search>smoothly-icon[name="search-outline"],
:host>.dropdown>.search>smoothly-icon[name="backspace-outline"] {
	color: rgb(var(--smoothly-input-foreground, var(--smoothly-color-contrast)));
	fill: rgb(var(--smoothly-input-foreground, var(--smoothly-color-contrast)));
	stroke: rgb(var(--smoothly-input-foreground, var(--smoothly-color-contrast)));
}


/* --- multiple options --- */
:host([multiple])::slotted(.dropdown>.menu>smoothly-item) {
	position: relative;
}
:host([multiple])::slotted(.dropdown>.menu>smoothly-item::before) {
	content: "";
	display: inline-block;
	width: 1rem;
	height: 1rem;
	margin-right: 0.5rem;
	border: 1px solid rgb(var(--smoothly-input-foreground));
	border-radius: 0.15rem;
	vertical-align: middle;
}
:host([multiple])::slotted(.dropdown>.menu>smoothly-item[selected]::before) {
	border-color: rgb(var(--smoothly-item-selected-foreground));
}
:host([multiple])::slotted(.dropdown>.menu>smoothly-item:hover::before) {
	border: 1px solid rgb(var(--smoothly-item-hover-foreground));
}
:host([multiple])::slotted(.dropdown>.menu>smoothly-item[selected]::after) {
	content: "✔";
	position: absolute;
	left: 0.65rem; 
	color: rgb(var(--smoothly-item-selected-foreground));
}
:host([multiple])::slotted(.dropdown>.menu>smoothly-item:hover::after) {
	color: rgb(var(--smoothly-item-hover-foreground));
}
:host>.dropdown {
	min-width: fit-content;
}
:host>.dropdown>.menu[hidden] {
	display: none;
}


